import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationPartItem } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationDetailResponse';
import OperationPartItemGroup from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/PartsSelection/OperationPartItemGroup';
import { Box, Flex, Text } from 'UI';

const OperationPartItemGroups = ({ partItemGroups }: { partItemGroups: OperationPartItem[] }) => {
  const { t } = useTranslation();

  return (
    <Flex direction={'column'} gap={15} padding={'0 16px 0 0'}>
      <Text type="heading4">{t('common.references', 'References')}</Text>
      <Flex minHeight={50} padding={'0 15px 0 60px'} align={'center'} gap={7} justify={'space-between'}>
        <Flex maxWidth={150} justify={'center'}>
          <Text type="base" bold>
            {t('catalog.reference', 'Reference')}
          </Text>
        </Flex>
        <Box width={80} />
        <Flex justify={'center'} maxWidth={230}>
          <Text type="base" bold>
            {t('common.designation', 'Designation')}
          </Text>
        </Flex>
        <Flex maxWidth={70} />
        <Flex maxWidth={70} justify={'center'}>
          {t('common.quantity', 'Quantity')}
        </Flex>
        <Flex justify={'center'}>
          <Text type="base" bold>
            {t('catalog.easy_basket.reference.details', 'Details')}
          </Text>
        </Flex>
        <Flex justify={'center'} maxWidth={200}>
          <Text type="base" bold>
            {t('catalog.easy_basket.price', 'Price')}
          </Text>
        </Flex>
        <Flex maxWidth={36} />
      </Flex>
      {partItemGroups.map((partItemGroup) => (
        <OperationPartItemGroup key={partItemGroup.itemGroup} itemGroup={partItemGroup} />
      ))}
    </Flex>
  );
};

export default OperationPartItemGroups;
